import React from "react";
import "../../../src/assets/css/components/skeletoloadig/WorkerHomeSkeleton.css";
const WorkerHomeSkeleton = () => {
  return (
    <div className="whs-page">

      {/* HERO */}
      <div className="whs-hero">

        <div className="whs-top">

          <div className="whs-avatar shimmer"></div>

          <div className="whs-user">
            <div className="whs-line whs-line-sm shimmer"></div>
            <div className="whs-line whs-line-lg shimmer"></div>
          </div>

          <div className="whs-bell shimmer"></div>

        </div>

        <div className="whs-card">

          <div>
            <div className="whs-line whs-line-sm shimmer"></div>
            <div className="whs-line whs-line-md shimmer"></div>
            <div className="whs-line whs-line-xs shimmer"></div>
          </div>

          <div className="whs-circle shimmer"></div>

        </div>

        <div className="whs-bottom">

          <div className="whs-pill shimmer"></div>

          <div className="whs-pill whs-pill-sm shimmer"></div>

        </div>

      </div>

      {/* STATS */}

      <div className="whs-stats">

        {[1,2,3,4].map((item)=>(
          <div className="whs-stat" key={item}>

            <div className="whs-icon shimmer"></div>

            <div className="whs-line whs-line-sm shimmer"></div>

            <div className="whs-line whs-line-xs shimmer"></div>

          </div>
        ))}

      </div>

      {/* ACTIVE JOBS */}

      <div className="whs-section">

        <div className="whs-title shimmer"></div>

        {[1,2].map((item)=>(
          <div className="whs-job" key={item}>

            <div className="whs-line whs-line-lg shimmer"></div>

            <div className="whs-line whs-line-md shimmer"></div>

            <div className="whs-line whs-line-sm shimmer"></div>

          </div>
        ))}

      </div>

      {/* NEW JOBS */}

      <div className="whs-section">

        <div className="whs-title shimmer"></div>

        {[1,2].map((item)=>(
          <div className="whs-job" key={item}>

            <div className="whs-line whs-line-lg shimmer"></div>

            <div className="whs-line whs-line-md shimmer"></div>

            <div className="whs-line whs-line-sm shimmer"></div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default WorkerHomeSkeleton;